<template>
    <div class="table">
        <div class="container" style="float:right;width:95%;">
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.serialNo" placeholder="编号"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-select v-model="form.moduleId" placeholder="评价模块" clearable >
                        <el-option
                            v-for="item in evaluateModules"
                            :key="item.id"
                            :label="item.moduleTitle"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.evaluateTitle" placeholder="评价指标"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.evaluateContent" placeholder="文字评价"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.name" placeholder="姓名"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.gradeName" placeholder="年级名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.className" placeholder="班级名称"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;"> 
                <el-date-picker
                    v-model="form.startDate"
                    type="date"
                    placeholder="评价开始日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
                    
            </div>
            <div style="display: inline-block; height:40px;">
                <el-date-picker
                    v-model="form.endDate"
                    type="date"
                    placeholder="评价结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                </el-date-picker> 
            </div>
            <div style="display: inline-block; height:40px;">
                <div style="width:160px;">
                    <el-input v-model="form.createName" placeholder="评价人"></el-input>
                </div>
            </div>
            <div style="display: inline-block; height:40px;">
                <el-button type="primary" icon="search" @click="common.page = 1;getData()">查询</el-button>
            </div>
            <div style="display: block; height:40px;float:right;">
                <el-button type="primary" icon="search" @click="exportMyExcel">导出Excel</el-button>
                <!-- <el-button type="primary" icon="search" @click="showDownloadTemplateDialog">下载评价模板</el-button>
                <el-button type="primary" icon="search" @click="triggerFileUpload">导入评价模板</el-button> -->
                <el-button type="primary" @click="showTemplateEvaluateDialog">模板评价</el-button>
                <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".xls,.xlsx">
                <el-button type="danger"  class="handle-del mr10" icon="el-icon-delete" @click="batchDelete">批量删除</el-button>
            </div>
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="550"
                v-loading="loading"
                :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                border
                default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" ></el-table-column>
                <el-table-column type="index"  label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="编号"  :show-overflow-tooltip="true" width="150">
                    <template slot-scope="scope">
                        <div v-if="scope.row.serialNo !=null && scope.row.serialNo !='' ">
                            {{scope.row.serialNo}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluateModule"  label="评价模块" width="130">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateModule == 1">
                            学生评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 2">
                            课堂评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 3">
                            班级评价/
                            <span v-if="scope.row.commonName != null">
                                {{scope.row.commonName}}/
                            </span>
                            {{scope.row.classEvaluateIndicatorsName}}
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 4">
                            实践评价
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 5">
                            教职评价
                            <span v-if="scope.row.commonName != null">
                                /{{scope.row.commonName}}
                            </span>
                            <span v-if="scope.row.classEvaluateIndicatorsName != null">
                                /{{scope.row.classEvaluateIndicatorsName}}
                            </span>
                        </div>
                        <div v-else-if="scope.row.evaluateModule == 6">
                            成果评价
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价对象" width="80">
                    <template slot-scope="scope">
                        <!--评价目标（1-班级，2-学生，3-教职）-->
                        <div v-if="scope.row.evaluateTarget == 1">
                            班级
                        </div>
                        <div v-else-if="scope.row.evaluateTarget == 2">
                            {{scope.row.name}}
                        </div>
                        <div v-else-if="scope.row.evaluateTarget == 3">
                            {{scope.row.name}}
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价类型"  :show-overflow-tooltip="true" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            表扬
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            待改进
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价指标"  :show-overflow-tooltip="true" width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 3">
                            无
                        </div>
                        <div v-else>
                            {{scope.row.evaluateTitle}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="文字评价"  :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 3">
                            {{scope.row.title}}
                        </div>
                        <div v-else>
                            {{scope.row.evaluateContent}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="评价分值"  width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.evaluateType == 1">
                            +{{scope.row.evaluateScore}}
                        </div>
                        <div v-else-if="scope.row.evaluateType == 2">
                            <span style="color: red;">{{scope.row.evaluateScore}}</span>
                        </div>
                        <div v-else>
                            {{scope.row.evaluateScore}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="年级名称" width="100"></el-table-column>
                <el-table-column prop="className" label="班级名称" width="100"></el-table-column>
                <el-table-column prop="evaluateTime" label="评价时间"   width="100"></el-table-column>
                <el-table-column prop="eventTime" label="事件时间"   width="100"></el-table-column>
                <el-table-column prop="createName" label="评价人"  width="80"></el-table-column>
                <el-table-column prop="" label="是否清零"  width="70">
                    <template slot-scope="scope">
                        <div v-if="scope.row.deleteSign == null 
                            || scope.row.deleteSign == '' ">
                            未清零
                        </div>
                        <div v-else style="color:red;">
                            已清零
                        </div>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="110px" style="text-align:'left'">
                    <template slot-scope="scope">
                        <el-button  v-if="scope.row.commonSign > 0"
                            @click.native.prevent="showData(scope.row)"
                            type="text"
                            size="small" style="color: #387EE8;">
                            查看附件
                        </el-button>
                        <el-button style="color: red"
                            @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

             <div class="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="common.page"
                    :page-size="common.pageSize"
                    :page-sizes="common.allSizes"
                    layout="total,sizes, prev, pager, next, jumper"
                    :total="common.total">
                </el-pagination>
            </div>
        </div>
        <!-- 查看附件弹出框 -->
        <div v-if="evaluateFileVisible">
            <evaluateFile ref="evaluateFile"></evaluateFile>
        </div>

        <!-- 下载评价模板弹出框 -->
        <!-- <download-template-dialog ref="downloadTemplateDialog"></download-template-dialog> -->
        <!-- 导入评价模板弹出框
        <import-template-dialog ref="importTemplateDialog"></import-template-dialog> -->
        <my-evaluate-panel ref="myEvaluatePanel"></my-evaluate-panel>
    </div>
</template>

<script>
    import axios from 'axios';
    import http from '../../../../common/http';
    import evaluateFile from './EvaluateFile.vue';
    import downloadTemplateDialog from './DownloadTemplateDialog.vue';
    import myEvaluatePanel from './MyEvaluatePanel.vue';
    // import importTemplateDialog from './ImportTemplateDialog.vue';

    export default {
        name:"",
        data(){
            return{
                evaluateFileVisible:false,
                common:{
                    total:0,            //总数据量
                    pageSize:30,        //每页条数
                    page:1,              //页码
                    isPage:1,            //是否分页
                    allSizes:[30,50,100], //每页条数筛选
                    checkboxArr:[]       //多选框数组
                },
                form:{
                    id:"",
                    deptId:"",
                    serialNo:"",
                    moduleId:"",
                    evaluateTitle:"",
                    evaluateContent:"",
                    name:"",
                    className:"",
                    gradeName:"",
                    startDate:"",
                    endDate:"",
                    createName:""
                },
                evaluateModules:[],
                data:[],
                loading:false,
                loadingText:"",
            }
        },
        components: {
            evaluateFile,
            myEvaluatePanel,
        },
        created:function () {
            // 用户信息
            let userinfo =JSON.parse(sessionStorage.getItem('userinfo'))
            // console.log('用户信息', JSON.stringify(userinfo))
            this.form.deptId = userinfo.deptId
            // 查询数据
            this.getData();
            this.getModuleBindIndicators();
        },
        methods:{
            // 显示下载评价模板弹窗
            showDownloadTemplateDialog() {
                this.$nextTick(() => {
                    this.$refs['downloadTemplateDialog'].showDialog();
                });
            },
            // 显示模板评价
            showTemplateEvaluateDialog(){
                this.$nextTick(() => {
                    this.$refs['myEvaluatePanel'].showDialog();
                });
            },
            // 触发文件选择框
            triggerFileUpload() {
                this.$refs.fileInput.click();
            },
            // 处理文件选择变化
            handleFileChange(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                // 验证文件类型
                let fileType = file.type;
                let isLt2M = file.size / 1024 / 1024 < 100;
                
                if (this.$constant.excelFileType.indexOf(fileType) == -1) {
                    this.$commonFn.showTip('导入文件只支持.xls与.xlsx', 3);
                    return;
                }

                if (!isLt2M) {
                    this.$commonFn.showTip('文件大小不能超过100MB!', 3);
                    return;
                }
                
                // 显示加载中
                const loadingInstance = this.$loading({ 
                    text: '正在导入数据，请稍候', 
                    spinner: 'el-icon-loading', 
                    background: 'rgba(0, 0, 0, 0.7)' 
                });
                
                // 获取用户信息
                let userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
                
                // 创建表单数据
                let uploadForm = new FormData();
                uploadForm.append('file', file);
                uploadForm.append('deptId', userinfo.deptId);
                
                // 发送请求
                this.$axios.post(this.evaluateDetailImportTemplateUrl, uploadForm).then((res) => {
                    if (res.data.status == 200) {
                        this.$commonFn.showTip(res.data.message, 5, true);
                        this.getData(); // 刷新数据
                    } else {
                        // this.$commonFn.showTip(res.data.message, 3);
                        this.$commonFn.showTip(res.data.message, 4, true);
                    }
                    loadingInstance.close();
                    // 重置文件输入框，以便再次选择同一文件
                    this.$refs.fileInput.value = '';
                }, (err) => {
                    console.log(err);
                    loadingInstance.close();
                    this.$refs.fileInput.value = '';
                });
            },
            indexMethod(index) {
                return (this.common.page-1)*this.common.pageSize+(index+1);
            },
            getData(){

                let url  = this.myEvaluateListUrl;
                let data = {
                    isPage:this.common.isPage,
                    page:this.common.page,
                    limit:this.common.pageSize,
                    serialNo:this.form.serialNo,
                    moduleId:this.form.moduleId,
                    evaluateTitle:this.form.evaluateTitle,
                    evaluateContent:this.form.evaluateContent,
                    name:this.form.name,
                    gradeName:this.form.gradeName,
                    className:this.form.className,
                    startDate:this.form.startDate==null?"":this.form.startDate,
                    endDate:this.form.endDate==null?"":this.form.endDate,
                    createName:this.form.createName,
                };
                
                // console.log(JSON.stringify(data))
                // return
                this.loading=true;
                this.loadingText="数据加载中...";
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.data = res.data.list;
                        this.common.total=res.data.total;   
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    this.loading=false;
                });
           },
           getModuleBindIndicators(){
                let url  = this.moduleBindIndicatorsHavePermissionModuleListUrl
                let data = {
                    deptId: this.form.deptId,
                }
                
                // console.log(JSON.stringify(data))
                // return
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.form.moduleId="";
                        this.evaluateModules = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                });
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                
                this.loading=true;
                this.loadingText="正在删除中...";

                let url = this.myEvaluateDelUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                     this.loading=false;
                    if(res.status == 200){
                        this.$commonFn.showTip(res.message,1);
                        this.common.page = 1;
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                })
            },
            //批量删除
            batchDelete(){
                if(this.common.checkboxArr.length != 0){
                    let checkIdArr=new Array();
                    for(var i=0;i<this.common.checkboxArr.length;i++){
                        if(this.common.checkboxArr[i]!=1){
                            checkIdArr.push(this.common.checkboxArr[i]);
                        }
                    }
                    let idStr =checkIdArr.join(",");
                    this.form.id= idStr;
                    this.$commonFn.showConfirm(this.delSuccess);
                }
                else{
                    this.$commonFn.showTip("请选择删除数据",2);
                }
            },
            handleSelectionChange(val){
                this.common.checkboxArr = [];
                for (let i = 0;i < val.length;i++){
                    this.common.checkboxArr.push(val[i].id);
                }
            },
            handleSizeChange(val) {
                this.common.pageSize = val;
                this.common.page = 1;
                this.getData();
            },
            handleCurrentChange(val) {
                this.common.page = val;
                this.getData();
            },
            showData(row){
                this.evaluateFileVisible=true;
                this.$nextTick(() => { 
                    this.$refs['evaluateFile'].init(this.form.deptId,row.id);
                })
            },
            exportMyExcel(){
                const maxCount = 65535
                if(this.common.total > maxCount){
                    let msg="导出数据超出"+maxCount+"条平台不支持，请缩小数据范围查询，然后再进行导出操作！"
                    this.$commonFn.showTip(msg,3)
                }else{
                    this.exportMyData()
                }
            },
            exportMyData(){
                this.loading=true;
                this.loadingText="正在导出中，导出过程时间可能会比较长，请耐心等待";
                let url=this.myEvaluateListExcelUrl;
                let param = new URLSearchParams();
                // param.append('isPage', this.common.isPage);
                // param.append('page', this.common.page);
                // param.append('limit', this.common.pageSize);
                param.append('serialNo', this.form.serialNo);
                param.append('moduleId', (this.form.moduleId=='0'?"":this.form.moduleId));
                param.append('evaluateTitle', this.form.evaluateTitle);
                param.append('evaluateContent', this.form.evaluateContent);
                param.append('name', this.form.name);
                param.append('gradeName', this.form.gradeName);
                param.append('className', this.form.className);
                param.append('startDate', this.form.startDate==null?"":this.form.startDate);
                param.append('endDate', this.form.endDate==null?"":this.form.endDate);
                param.append('createName', this.form.createName);
                
                // 获取当前登录用户的学校
                let schoolNameArr=JSON.parse(sessionStorage.getItem("schoolName"));
                
                axios({
                    method: "post",
                    url: url,
                    data: param,
                    responseType: "blob"
                }).then(res => {
                    const link = document.createElement("a");
                    let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
                    link.style.display = "none";
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", schoolNameArr[0]+'-我的评价.xls');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.loading=false;
                }).catch(error => {
                    console.log(error);
                    this.loading=false;
                });

            },
        },
        mixins: [http]
    }

</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/MyEvaluate.vue